export const PaymentBadges = () => {
  const paymentMethods = [
    {
      name: 'iDEAL',
      icon: '/assets/images/payment-methods/ideal.svg',
    },
    {
      name: 'Credit Card',
      icon: '/assets/images/payment-methods/creditcard.svg',
    },
    {
      name: 'PayPal',
      icon: '/assets/images/payment-methods/paypal.svg',
    },
    {
      name: 'Bancontact',
      icon: '/assets/images/payment-methods/bancontact.svg',
    },
    {
      name: 'Apple Pay',
      icon: '/assets/images/payment-methods/applepay.svg',
    },
    {
      name: 'Google Pay',
      icon: '/assets/images/payment-methods/googlepay.svg',
    },
    {
      name: 'Klarna',
      icon: '/assets/images/payment-methods/klarna.svg',
    },
  ]

  return (
    <div className="flex flex-wrap items-center gap-2 mt-2">
      {paymentMethods.map((method) => (
        <div key={method.name} className="flex items-center" title={method.name}>
          <img
            src={method.icon}
            alt={`${method.name} payment method`}
            className="h-8 object-contain"
            loading="lazy"
          />
        </div>
      ))}
    </div>
  )
}
